import { styled } from "@uhg-abyss/web/tools/styled";
import { LoadingSpinner } from "@uhg-abyss/web/ui/LoadingSpinner";
import type { FC } from "react";

const DEFAULT_SPINNER_COLOR = "$app.color.text.primary.alt";

const LoaderOverlay = styled("div", {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "$app.color.surface.overlay",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999, // High z-index to overlay other content
  color: "$app.color.text.primary.alt",
  fontSize: "1.1rem",
  fontWeight: "500",
  textAlign: "center",
  padding: "2rem",
  boxSizing: "border-box",
});

interface LoadingOverlayProps {
  isLoading: boolean;
  size?: "xs" | "lg" | "xl";
  ariaLoadingLabel?: string;
  color?: string;
}

export const LoadingOverlay: FC<LoadingOverlayProps> = ({
  isLoading,
  size = "xl",
  ariaLoadingLabel = "Loading...",
  color = DEFAULT_SPINNER_COLOR,
}) => {
  if (!isLoading) return null;

  return (
    <LoaderOverlay data-testid="test-id-common-loading-overlay">
      <LoadingSpinner
        size={size}
        ariaLoadingLabel={ariaLoadingLabel}
        color={color}
        isLoading={true}
      />
    </LoaderOverlay>
  );
};
